"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MpvPlayer_1 = __importDefault(require("./MpvPlayer"));
exports.default = MpvPlayer_1.default;
